<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fill-height>
      <div style="width:100%;max-height:22px;display:flex;align-items:center;">
        <v-radio-group v-model="dataType" row style="display:flex;justify-content:flex-end;align-items:center; top: -8px;">
          <v-radio flat value="values" label="Values" color="rgb(51,82,128)"/>
          <v-radio flat value="diff" label="Diff. %" color="rgb(51,82,128)"/>
        </v-radio-group>
      </div>
      <v-layout row style="height:calc(100% - 32px);">
        <v-flex d-flex md6>
          <v-layout column fill-height>
            <v-flex ref="tlChart" d-flex md3 :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['pcomp']" v-bind:active="active" v-bind:chartOptions="chartData['pcomp']" v-bind:title="titles['pcomp']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex md3 :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['pmax']" v-bind:active="active" v-bind:chartOptions="chartData['pmax']" v-bind:title="titles['pmax']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex md3 :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['tTurbIn']" v-bind:active="active" v-bind:chartOptions="chartData['tTurbIn']" v-bind:title="titles['tTurbIn']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex md3 :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['tcspeed']" v-bind:active="active" v-bind:chartOptions="chartData['tcspeed']" v-bind:title="titles['tcspeed']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex md3 v-if="gasLayout" :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['gasMode']" v-bind:active="active" v-bind:chartOptions="chartData['gasMode']" v-bind:title="titles['gasMode']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex md6>
          <v-layout column fill-height>
            <v-flex d-flex :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['pscav']" v-bind:active="active" v-bind:chartOptions="chartData['pscav']" v-bind:title="titles['pscav']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['tscav']" v-bind:active="active" v-bind:chartOptions="chartData['tscav']" v-bind:title="titles['tscav']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['soPresDispl']" v-bind:active="active" v-bind:chartOptions="chartData['soPresDispl']" v-bind:title="titles['soPresDispl']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['fRailPres']" v-bind:active="active" v-bind:chartOptions="chartData['fRailPres']" v-bind:title="titles['fRailPres']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
            <v-flex d-flex v-if="gasLayout" :style="'max-height:'+maxHeight+'%;'">
              <TimelineChart v-if="chartData['GasRailPress']" v-bind:active="active" v-bind:chartOptions="chartData['GasRailPress']" v-bind:title="titles['GasRailPress']" v-bind:engineOff="engineOff" v-bind:engineOn="engineOn" v-bind:legened="'engineState'"/>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>

</template>

<script>

import TimelineChart from '../controls/TimelineChart'

import Highcharts from 'highcharts'

import {globalStore} from "../main.js"
import {vessels} from "../main";

export default {
  name: 'EngineGraphs',
  components: {
    TimelineChart
  },
  props: {
    active: Boolean
  },
  data() {
    return {
      chartData: {},
      dataType: 'values',
      titles: {},
      engineOn: 'rgb(70, 159, 60)', //Green
      // engineOn: 'rgb(139, 185, 221)', //Light blue
      engineOff: 'rgb(167, 42, 48)', //Red
      // engineOff: 'rgb(192, 192, 192)', //Light gray
      enspThreshold: 10
    }
  },
  methods: {
    average: function (param, count, data, timestamp) {
      let sum = 0;

      for (let i = 1; i <= count; i++) {
        if (data[timestamp][param + i] != -1000) sum += data[timestamp][param + i];
        else count--;
      }

      if (sum == 0 || count == 0)
        return -1000;
      else
        return sum / count;
    },
    setData() {
      if (this.dataType == 'values')
        this.setValuesData();
      else
        this.setDiffData();

      globalStore.loading = false;
    },
    setValuesData() {
      let timeStamps = globalStore.signals.timestamps,
          params = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres', 'ensp', 'load'],
          elCount = [this.cylCount, this.cylCount, this.tcCount, 0, this.tcCount, 0, 0, 0, 0, 0],
          refs = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresSetpoint', 'fRailPresSet', 'ensp', 'load'];

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      var units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      for (let p = 0; p < params.length; p++) {
        this.$set(this.chartData, params[p], {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            crosshair: true
          },
          yAxis: {
            title: {
              text: '[' + units[params[p]] + ']',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) allSeries = this.points[0].series.chart.series
              else allSeries = this.point.series.chart.series;

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  })

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }


                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Value',
              type: 'scatter',
              // color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
              visible: false
            },
          ]

        });

        let yMin;

        for (let i = 0; i < timeStamps.length; i++) {
          let val, rfr;
          if (elCount[p] == 0) val = globalStore.signals[timeStamps[i]][params[p]];
          else val = this.average(params[p], elCount[p], globalStore.signals, timeStamps[i]);

          if ((yMin == undefined) || (yMin > val)) yMin = val;

          if (params[p] == 'fRailPres') rfr = globalStore.signals[timeStamps[i]][refs[p]];
          else if (globalStore.reference.timestamps.includes(timeStamps[i])) {
            if (elCount[p] == 0) rfr = globalStore.reference[timeStamps[i]][refs[p]];
            else rfr = this.average(refs[p], elCount[p], globalStore.reference, timeStamps[i]);
          } else rfr = -1000;

          let color = 'rgb(51,82,128)';

          let dt = new Date(timeStamps[i]);

          if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

            if ((minLimit != null) && (maxLimit != null)) {

              let temp = ((val - rfr) / val) * 100;

              if ((temp > minLimit) && (temp < maxLimit)) color = 'rgb(60, 171, 48)';
              else color = 'rgb(255, 184, 29)';

              let min = rfr / (1 - minLimit / 100);
              let max = rfr / (1 - maxLimit / 100);

              if (yMin > min) yMin = min;

              this.chartData[params[p]].series[1].data.push({
                x: dt,
                low: min,
                high: max
              });
            }
          }

          if (val != -1000)
            this.chartData[params[p]].series[0].data.push({
              x: dt,
              y: val,
              color: color
            });
        }

        if (yMin <= 0) this.chartData[params[p]].yAxis.min = 0;

        this.addEngineState(params[p], timeStamps);
      }

      if (globalStore.gasEngine) {
        var vessel = Object.values(vessels.vessels).filter(function (i) {
          return i.imo == globalStore.selectedIMO
        })[0];

        this.$set(this.chartData, 'gasMode', {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            crosshair: true
          },
          yAxis: {
            title: {
              text: undefined
            },
            labels: {
              step: 1
            },
            categories: ((vessel.control == 2) ? ['', 'Diesel', 'Transfer', 'Gas', 'Gas-DCC', 'Fuel sharing', 'Diesel-Manual', 'CSM', 'iCER Diesel']  : ['Diesel', 'Gas']) //Set Y axis based on the control system

          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return s + '<br/>' + point.series.name + ': ' + point.series.yAxis.categories[point.y];
              }, '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>');
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Engine Mode',
              type: 'line',
              step: 'center',
              color: 'rgb(51,82,128)',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
          ]
        });

        this.$set(this.chartData, 'GasRailPress', {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            crosshair: true
          },
          yAxis: {
            title: {
              text: '[bar]',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) allSeries = this.points[0].series.chart.series
              else allSeries = this.point.series.chart.series;

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  })

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }


                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Fuel Side',
              type: 'scatter',
              // color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Exhaust Side',
              type: 'scatter',
              // color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
          ]
        });

        let yMin;

        for (let i = 0; i < timeStamps.length; i++) {
          let gas = globalStore.signals[timeStamps[i]]['gasOn'],
              dt = new Date(timeStamps[i]),
              fuel = globalStore.signals[timeStamps[i]]['GasRailPress1'],
              exhaust = globalStore.signals[timeStamps[i]]['GasRailPress2'];

          if ((yMin == undefined) || (yMin > fuel)) yMin = fuel;

          if (yMin > exhaust) yMin = exhaust;

          if (vessel.control == 2) {
            if (globalStore.signals[timeStamps[i]]['fuelMode'] != -1000)
              this.chartData['gasMode'].series[0].data.push({x: dt, y: Math.round(globalStore.signals[timeStamps[i]]['fuelMode'])});
          } else if (gas != -1000) {
            if (gas == 0)
              this.chartData['gasMode'].series[0].data.push({x: dt, y: 0});
            else
              this.chartData['gasMode'].series[0].data.push({x: dt, y: 1});
          }

          let rfr = -1000;

          if (Object.keys(globalStore.signals[timeStamps[i]]).includes('GasRailPressSetPoint'))
            rfr = globalStore.signals[timeStamps[i]]['GasRailPressSetPoint'];

          let fuelColor = 'rgb(51,82,128)', exhColor = 'rgb(51,82,128)';

          if (rfr != -1000 && Object.keys(limits).includes('GasRailPress')) {
            let minLimit = limits['GasRailPress'][0], maxLimit = limits['GasRailPress'][1];

            if ((minLimit != null) && (maxLimit != null)) {
              let fuelTemp = ((fuel - rfr) / fuel) * 100,
                  exhTemp = ((exhaust - rfr) / exhaust) * 100;

              if ((fuelTemp > minLimit) && (fuelTemp < maxLimit))
                fuelColor = 'rgb(60, 171, 48)';
              else
                fuelColor = 'rgb(255, 184, 29)';

              if ((exhTemp > minLimit) && (exhTemp < maxLimit))
                exhColor = 'rgb(60, 171, 48)';
              else
                exhColor = 'rgb(255, 184, 29)';

              let min = rfr / (1 - minLimit / 100);
              let max = rfr / (1 - maxLimit / 100);

              this.chartData['GasRailPress'].series[2].data.push({
                x: dt,
                low: min,
                high: max
              });
            }
          }

          if (fuel != -1000)
            this.chartData['GasRailPress'].series[0].data.push({
              x: dt,
              y: fuel,
              color: fuelColor
            });

          if (exhaust != -1000)
            this.chartData['GasRailPress'].series[1].data.push({
              x: dt,
              y: exhaust,
              color: exhColor
            });
        }

        if (yMin <= 0) this.chartData['GasRailPress'].yAxis.min = 0;

        this.addEngineState('gasMode', timeStamps, 1, 0);
        this.addEngineState('GasRailPress', timeStamps);
      }
    },
    setDiffData() {
      var limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      let timeStamps = globalStore.signals.timestamps;

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      let params = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres'],
          elCount = [this.cylCount, this.cylCount, this.tcCount, 0, this.tcCount, 0, 0, 0],
          refs = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresSetpoint', 'fRailPresSet'];

      for (let p = 0; p < params.length; p++) {
        this.$set(this.chartData, params[p], {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            title: {
              text: 'Time',
              align: 'high'
            },
            crosshair: true
          },
          yAxis: {
            min: null,
            title: {
              text: '[%]',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) allSeries = this.points[0].series.chart.series
              else allSeries = this.point.series.chart.series;

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  })

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }


                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Difference %',
              type: 'scatter',
              //color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
          ]
        });

        for (let i = 0; i < timeStamps.length; i++) {
          let val, rfr;
          if (elCount[p] == 0) val = globalStore.signals[timeStamps[i]][params[p]];
          else val = this.average(params[p], elCount[p], globalStore.signals, timeStamps[i]);

          if (params[p] == 'fRailPres') rfr = globalStore.signals[timeStamps[i]][refs[p]];
          else if (globalStore.reference.timestamps.includes(timeStamps[i])) {
            if (elCount[p] == 0) rfr = globalStore.reference[timeStamps[i]][refs[p]];
            else rfr = this.average(refs[p], elCount[p], globalStore.reference, timeStamps[i]);
          } else rfr = -1000;

          let color = 'rgb(51,82,128)';

          let dt = new Date(timeStamps[i]);

          if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

            let temp = ((val - rfr) / val) * 100;

            if ((minLimit != null) && (maxLimit != null)) {

              if ((temp > minLimit) && (temp < maxLimit)) color = 'rgb(60, 171, 48)';
              else color = 'rgb(255, 184, 29)';

              this.chartData[params[p]].series[1].data.push({
                x: dt,
                low: minLimit,
                high: maxLimit
              });
            }

            this.chartData[params[p]].series[0].data.push({
              x: dt,
              y: temp,
              color: color
            });

          }
        }

        this.addEngineState(params[p], timeStamps);
      }

      if (globalStore.gasEngine) {
        var vessel = Object.values(vessels.vessels).filter(function (i) {
          return i.imo == globalStore.selectedIMO
        })[0];

        this.$set(this.chartData, 'gasMode', {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            crosshair: true
          },
          yAxis: {
            title: {
              text: undefined
            },
            labels: {
              step: 1
            },
            categories: ((vessel.control == 2) ? ['', 'Diesel', 'Transfer', 'Gas', 'Gas-DCC', 'Fuel sharing', 'Diesel-Manual', 'CSM', 'iCER Diesel'] : ['Diesel', 'Gas']) //Set Y axis based on the control system

          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return s + '<br/>' + point.series.name + ': ' + point.series.yAxis.categories[point.y];
              }, '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>');
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Engine Mode',
              type: 'line',
              step: 'center',
              color: 'rgb(51,82,128)',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
          ]
        });

        this.$set(this.chartData, 'GasRailPress', {
          credits: {enabled: false},
          time: {
            useUTC: true
          },
          chart: {
            height: 100,
            zoomType: 'xy'
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Time',
              align: 'high'
            },
            labels: {
              format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
              rotation: 0
            },
            crosshair: true
          },
          yAxis: {
            min: null,
            title: {
              text: '[%]',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              var s = '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>',
                  actTime = this.x, allSeries = [];

              if (this.points) allSeries = this.points[0].series.chart.series
              else allSeries = this.point.series.chart.series;

              allSeries.forEach(series => {

                if (series.name != 'State') {
                  var diff = series.closestPointRange, actPoint = null;

                  series.data.forEach(point => {
                    let temp = Math.abs(actTime - point.x)

                    if ((diff == null) || (temp < diff)) {
                      actPoint = point;
                      diff = temp;
                    }
                  })

                  if (actPoint != null) {
                    if (actPoint.series.type == 'scatter') {
                      s += '<br/> ' + actPoint.series.name + ': ' + actPoint.y.toFixed(2);
                    } else {
                      s += '<br/> ' + actPoint.series.name + ': from ' + actPoint.low.toFixed(2) + ' to ' + actPoint.high.toFixed(2);
                    }
                  }


                }
              });
              return s;
            },
            shared: true
          },
          legend: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              name: 'Fuel Side %',
              type: 'scatter',
              // color: 'transparent',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Exhaust Side %',
              type: 'scatter',
              // color: 'transparent',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 3
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'Acceptable Range',
              type: 'arearange',
              animation: false,
              data: [],
              marker: {
                enabled: false
              },
              color: 'rgb(219, 219, 219)',
              fillOpacity: 0.6,
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
            {
              name: 'State',
              type: 'line',
              color: 'transparent',
              animation: false,
              data: [],
              marker: {
                radius: 0
              },
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            },
          ]
        });

        for (let i = 0; i < timeStamps.length; i++) {
          let gas = globalStore.signals[timeStamps[i]]['gasOn'],
              dt = new Date(timeStamps[i]),
              fuel = globalStore.signals[timeStamps[i]]['GasRailPress1'],
              exhaust = globalStore.signals[timeStamps[i]]['GasRailPress2'];

          if (vessel.control == 2) {
            if (globalStore.signals[timeStamps[i]]['fuelMode'] != -1000)
              this.chartData['gasMode'].series[0].data.push({x: dt, y: Math.round(globalStore.signals[timeStamps[i]]['fuelMode'])});
          } else if (gas != -1000) {
            if (gas == 0)
              this.chartData['gasMode'].series[0].data.push({
                x: dt,
                y: 0
              });
            else
              this.chartData['gasMode'].series[0].data.push({
                x: dt,
                y: 1
              });
          }

          let rfr = -1000;

          if (Object.keys(globalStore.signals[timeStamps[i]]).includes('GasRailPressSetPoint'))
            rfr = globalStore.signals[timeStamps[i]]['GasRailPressSetPoint'];

          let fuelColor = 'rgb(51,82,128)',
              exhColor = 'rgb(51,82,128)';

          if ((rfr != -1000) && (Object.keys(limits).includes('GasRailPress'))) {
            let fuelTemp = ((fuel - rfr) / fuel) * 100,
                exhTemp = ((exhaust - rfr) / exhaust) * 100,
                minLimit = limits['GasRailPress'][0],
                maxLimit = limits['GasRailPress'][1];

            if ((minLimit != null) && (maxLimit != null)) {
              if ((fuelTemp > minLimit) && (fuelTemp < maxLimit))
                fuelColor = 'rgb(60, 171, 48)';
              else
                fuelColor = 'rgb(255, 184, 29)';

              if ((exhTemp > minLimit) && (exhTemp < maxLimit))
                exhColor = 'rgb(60, 171, 48)';
              else
                exhColor = 'rgb(255, 184, 29)';

              this.chartData['GasRailPress'].series[2].data.push({
                x: dt,
                low: minLimit,
                high: maxLimit
              });
            }

            this.chartData['GasRailPress'].series[0].data.push({
              x: dt,
              y: fuelTemp,
              color: fuelColor
            });

            this.chartData['GasRailPress'].series[1].data.push({
              x: dt,
              y: exhTemp,
              color: exhColor
            });
          }
        }

        this.addEngineState('gasMode', timeStamps, 1, 0);
        this.addEngineState('GasRailPress', timeStamps);
      }
    },
    addEngineState(param, timeStamps, calcMax, calcMin) {
      if (this.chartData[param].series[0].data.length) {
        var values = this.chartData[param].series[0].data.map(function (i) {
              return i.y;
            }),
            min = Math.min(...values),
            max = Math.max(...values),
            color = 'rgba(0,0,0,0)';

        if (typeof calcMax != 'undefined')
          max = calcMax;

        if (typeof calcMin != 'undefined')
          min = calcMax;

        var plotLines = [],
            previousState = null,
            dataSeriesIndex = this.chartData[param].series.map(function (i) {
              return i.name
            }).indexOf('State'); //Lookup state series in chart config

        for (let i = 0; i < timeStamps.length; i++) {
          let val,
              currentState;

          //If ensp greater or equal to 10 the engine running.
          if (Math.abs(globalStore.signals[timeStamps[i]]['ensp']) >= this.enspThreshold) {
            val = max;
            currentState = true;
          } else {
            val = min;
            currentState = false;
          }

          let dt = new Date(timeStamps[i]);

          // this.chartData[param].series[dataSeriesIndex].data.push({
          //     x: dt,
          //     y: val,
          //     color: color
          // });

          if (i == 0 || i == (timeStamps.length - 1)) {
            plotLines.push({
              color: ((currentState) ? this.engineOn : this.engineOff),
              width: 3,
              value: dt
            });
          } else if (previousState != currentState) {
            plotLines.push({
              color: ((currentState) ? this.engineOn : this.engineOff),
              width: 3,
              value: dt
            });
          }

          previousState = currentState;
        }

        this.chartData[param].xAxis.plotLines = plotLines;
      }
    },
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    gasLayout: function () {
      return globalStore.gasEngine;
    },
    maxHeight: function () {
      if (globalStore.gasEngine)
        return 20;
      else
        return 25;
    },
  },
  watch: {
    dataType: function () {
      this.setData();
    },
    dataLoaded: function () {
      if (this.dataLoaded != '')
        this.setData();
    },
  },
  mounted() {
    let params = ['ensp', 'load', 'pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres'];

    var mapping = globalStore.mapping[globalStore.selectedIMO];

    if (typeof mapping == 'undefined') {
      mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
    }

    for (let p = 0; p < params.length; p++) {
      this.$set(this.titles, params[p], mapping['mapping'][params[p]]);
    }

    this.$set(this.titles, 'gasMode', 'Engine Mode');
    this.$set(this.titles, 'GasRailPress', 'Gas Rail Pressure');

    this.setData();
  }
}
</script>

<style scoped>

</style>